export class OrganisationRole {
    id: number = -1;
    name: string = '';
    fullCompanyAccess = false;
    permissions: number[] = [];
    isDefaultRole = false;
    numUsers = 0;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.name = data.name ?? this.name;
        this.fullCompanyAccess = data.full_company_access ?? this.fullCompanyAccess;
        this.permissions = data.permissions ?? [];
        this.isDefaultRole = data.is_default_role ?? false;
        this.numUsers = data.num_users ?? 0;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            name: this.name,
            permissions: this.permissions,
            full_company_access: this.fullCompanyAccess,
            is_default_role: this.isDefaultRole,
            num_users: this.numUsers,
        };
    }

    clone(): OrganisationRole {
        return new OrganisationRole().deserialize(this.serialize());
    }

    static Sort(r1: OrganisationRole, r2: OrganisationRole): number {
        return r1.name.localeCompare(r2.name);
    }
}
